import React from "react";
import { Wrapper, Content } from "./style";

// import config from "../../config.json";
import docs from "../../assets/docs.json"
// import logo from "assets/img/logo_white.png";
import bg from "assets/img/bg.jpg";

//Components
import Background from "components/Background";

//3rd party
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import Menu from "components/Menu";
import { useState } from "react";
import { useEffect } from "react";
import anime from "animejs";

export default function(props) {
  const [localState, setLocalState] = useState({ isOpen: false });
  useEffect(() => {
    const tgt = document.getElementsByClassName("_menu_ref")[0];
    if (!tgt) {
      return;
    }

    const toggleMenu = () => {
      // //console.log("clicou");
      setLocalState({ ...localState, isOpen: !localState.isOpen });
    };

    tgt.addEventListener("click", toggleMenu);

    return () => {
      tgt.removeEventListener("click", toggleMenu);
    };
  }, [localState.isOpen]);

  useEffect(() => {
    anime
      .timeline({
        easing: `easeInOutQuad`,
        // delay: (el, i) => i * 100
      })
      .add({
        targets: [".rowUp.first"],
        translateY: [50, 0],
        scale: [1.1, 1],
        opacity: [0, 1],
      })
      .add(
        {
          targets: [".rowUp:not(.first)"],
          translateY: [50, 0],
          scale: [1.1, 1],
          opacity: [0, 1],
        },
        `-=500`
      )
      .play();
  }, []);

  return (
    <>
      <Background image={bg}>
        <Wrapper>
          <Container fluid>
            <Row
              style={{
                top: 0,
                position: `fixed`,
                width: `100%`,
                zIndex: !!localState.isOpen ? 99999 : 10,
              }}
            >
              <Menu></Menu>
            </Row>
            <div id="conteudo">
              <Row className="text-center mt-0 mt-md-5">
                <Col>
                  <Content.mainTitle>Documentos da oferta</Content.mainTitle>
                  <Container>
                    <Row>
                      <Col className="col-12 col-md-6 offset-0 offset-md-3">
                        <Content.subtitle>
                          Aviso ao mercado
                        </Content.subtitle>
                      </Col>
                    </Row>
                    <Row className="text-justify">
                      <Col className="col-12 col-md-6 offset-0 offset-md-3"></Col>
                    </Row>
                    <iframe
                      allow="autoplay; fullscreen"
                      scrolling="auto"
                      src={docs.avisoAoMercado}
                    ></iframe>
                    <div className="btDoc">
                      <Button
                        onClick={() => {
                          window.open(docs.avisoAoMercado, "_blank");
                        }}
                        className="p-4 btn-sm btNovaJanela"
                      >
                        ABRIR EM NOVA JANELA
                      </Button>
                    </div>
                  </Container>
                </Col>
              </Row>
              <Row>
                <Col className="col-10 offset-1">
                  <h1> </h1>
                </Col>
              </Row>
            </div>
          </Container>
        </Wrapper>
      </Background>
    </>
  );
}
